import {createSlice} from "@reduxjs/toolkit";
import {TAppInitialState} from "@/types/redux/appTypes";

const initialState: TAppInitialState = {
    fetchList: [],
    isBannerVisible: true,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setAppField: (
            state: TAppInitialState,
            {payload}: { payload: TAppInitialState }
        ) => {
            return {...state, ...payload};
        },
        startFetch: (state: TAppInitialState, {payload}: { payload: string }) => {
            state.fetchList.push(payload);
        },
        endFetch: (state: TAppInitialState, {payload}: { payload: string }) => {
            state.fetchList = state.fetchList.filter((el) => el !== payload);
        },
        hideBanner: (state: TAppInitialState) => {
            state.isBannerVisible = false;
        },
    },
});

export const {
    startFetch,
    endFetch,
    hideBanner,
} = appSlice.actions;

export default appSlice.reducer;
